import { TwoFAOutlineIcon } from 'foundations-assets/icons/components/TwoFAOutlineIcon';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useIsPillBorderRadius } from 'portals-platform-lib';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SensitiveHiddenMessage = () => {
  const isUsingPillBorderRadius = useIsPillBorderRadius();
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: "row",
    alignItems: "start",
    gap: "300",
    padding: "600",
    borderRadius: isUsingPillBorderRadius ? '0' : '300',
    borderWidth: "100",
    borderStyle: "dashed",
    borderColor: "border-core-subtle",
    backgroundColor: "fill-surface-default",
    children: [/*#__PURE__*/_jsx(TwoFAOutlineIcon, {
      size: "500",
      color: "icon-core-subtle",
      "aria-hidden": "true"
    }), /*#__PURE__*/_jsxs(Flex, {
      flex: "1",
      minInlineSize: "0",
      flexDirection: "column",
      gap: "300",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "p",
        typography: "heading-100",
        color: "text-core-default",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customer-portal-app.ticketThread.messageContent.isSensitive"
        })
      }), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "column",
        gap: "200",
        "aria-hidden": "true",
        children: [/*#__PURE__*/_jsx(View, {
          blockSize: "20px",
          inlineSize: "360px",
          maxInlineSize: "100%",
          borderRadius: "100",
          backgroundColor: "fill-surface-recessed"
        }), /*#__PURE__*/_jsx(View, {
          blockSize: "20px",
          inlineSize: "240px",
          maxInlineSize: "100%",
          borderRadius: "100",
          backgroundColor: "fill-surface-recessed"
        })]
      })]
    })]
  });
};